const jobs = {
  title: '岗位管理',
  projectsTitle: '招聘项目',
  projectsSubtitle: '每个会话对应一个岗位项目，继续进入 Agent 对话或处理候选人。',
  filterProjects: '筛选项目',
  allJobs: '所有岗位',
  openJobs: '开放岗位',
  closedJobs: '已关闭岗位',
  draftJobs: '草稿',
  searchPlaceholder: 'Search by job_name /按照名字搜索信息',
  batchParseVip: '批量解析岗位（VIP）',
  jobProfileCol: '岗位名称',
  projectSessionCol: '项目 / 会话',
  jobTalentCol: '岗位人才',
  recommendedTalentCol: '推荐人才',
  statusCol: '状态',
  candidateTotalCol: '候选人总数',
  openToWorkCol: 'open to work',
  matchedTalentCol: '匹配人才',
  localImport: '本地导入',
  talkToAi: 'Agent编辑',
  agentEdit: 'Agent 编辑',
  agentAction: 'Agent会话',
  jobTalentAction: '岗位人才',
  talentRecommendAction: '人才推荐',
  linkedinSearch: '领英搜索',
  bindCandidate: '绑定候选人',
  moreAction: '更多',
  backToTop: '返回顶部',
  statusTagOpen: '开放岗位',
  statusTagClosed: '已暂停',
  statusTagDraft: '草稿',
  projectStatusOpen: '进行中',
  projectStatusClosed: '暂停',
  projectStatusDraft: '草稿',
  continueImport: '领英搜索',
  continueEdit: '继续编辑',
  openDraft: '打开',
  recommendTag: 'EasyHireAI 人才推荐',
  processingTag: '处理中',
  openAtLabel: '岗位开启时间',
  closeAtLabel: '岗位关闭时间',
  talentRecommendations: {
    titlePrefix: '为你推荐',
    titleSuffix: '位候选人',
    partialSubtitle: '正在继续为你查找候选人，已找到的结果会先展示',
    completedSubtitle: '已根据当前条件完成候选人推荐',
    cacheSubtitle: '已为你显示最近一次推荐结果',
    runningSubtitle: '正在基于本次搜索策略匹配候选人',
    refresh: '继续推荐',
    // C1 / C2: people meeting the hard conditions, and how many are shown.
    matchTotal: '潜在人才库 {count} 人',
    matchTotalCapped: '潜在人才库 1k+ 人',
    shownCount: '已推荐 {count} 人',
    refreshConfirmTitle: '继续推荐候选人',
    refreshConfirmDescription:
      '现有 {existing} 位候选人会保留，本次最多追加 {count} 位，并扣除 {points} 个 AI积分。',
    refreshConfirmButton: '确认追加',
    refreshRunningTitle: '正在追加候选人',
    refreshRunningDesc: '已有结果会保留，新候选人完成后自动加入列表。',
    refreshSuccess: '已新增 {count} 位候选人，当前共 {total} 位。',
    refreshFailed: '追加推荐失败',
    locked: '待解锁',
    lockedBasicInfo: '基本信息已打码',
    aiMatchExhaustedTitle: 'AI积分不足',
    aiMatchExhaustedDescription:
      '本次推荐中还有 {count} 位人才尚未解锁，每位需 2 AI积分。升级会员后返回本页面，系统会按当前可用积分尽量解锁；余额不足时仅解锁部分人才，其余继续保持锁定。',
    upgradeMembership: '升级会员',
    aiMatchUnlockSuccess: '已解锁 {count} 位人才，每位 2 积分，共消耗 {points} AI积分。',
    aiMatchUnlockPartial:
      '已解锁 {unlocked} 位人才，消耗 {points} AI积分；余额不足，仍有 {locked} 位保持锁定（每位 2 积分）。',
    aiMatchUnlockNone: '当前 AI积分不足，{locked} 位人才仍保持锁定（每位需 2 积分）。',
    addAll: '全部加入岗位',
    allAdded: '已全部加入岗位',
    criteria: '条件',
    noCriteria: '暂无条件',
    adjustCriteria: '编辑筛选条件',
    filtersTitle: '编辑搜索筛选条件',
    filterSavedState: '已保存条件',
    filterDraftState: '未保存条件',
    filterSearchPlaceholder: '搜索筛选项',
    filterHideInactive: '隐藏未启用筛选项',
    filterMatchCount: '{count} 个匹配',
    filtersGeneral: '基础条件',
    filtersCore: '核心筛选',
    filtersSignals: '匹配信号',
    filtersLocations: '地点',
    filtersJob: '岗位',
    filtersCompany: '公司',
    filtersSkills: '技能与关键词',
    filtersEducation: '教育',
    filtersLanguages: '语言',
    filtersPower: '高级筛选',
    filtersScoring: '评分标准',
    filtersExcludeRisk: '排除条件',
    filterRole: '岗位角色',
    filterRolePlaceholder: '例如：后端工程师',
    filterIndustry: '行业',
    filterIndustryPlaceholder: '例如：AI SaaS',
    filterIndustries: '行业标签',
    filterSeniority: '职级',
    filterSeniorityPlaceholder: '例如：资深',
    filterSeniorityLevels: '职级',
    filterRoleTypes: '岗位类型',
    filterJobFunctions: '职能',
    filterExperience: '工作年限',
    filterAge: '年龄',
    filterExperiencePlaceholder: '例如：3-8 年',
    filterRangeMinPlaceholder: '最低',
    filterRangeMaxPlaceholder: '最高',
    filterRangeSeparator: '至',
    filterYearsInCurrentRole: '当前岗位年限',
    filterRecentlyChangedJobs: '最近换岗',
    filterJobChangeFrequency: '跳槽频率',
    filterTitles: '职位名称',
    filterExcludeJobTitles: '排除职位',
    filterCurrentTitleOnly: '只看当前职位',
    filterRecentWorkTitleOnly: '最近工作经历职位',
    filterIncludeRelatedTitles: '包含相关职位',
    filterMatchExperience: '匹配经历范围',
    filterKeywords: '关键词',
    filterSkills: '技能',
    filterSkillsAndKeywords: '技能与关键词',
    filterLocations: '地点',
    filterCurrentWorkLocations: '当前工作地点',
    filterPastWorkLocations: '过往工作地点',
    filterLocationRadius: '地点半径',
    filterLocationRadiusPlaceholder: '1-500 miles',
    filterCompanies: '目标公司',
    filterCompanyEvidence: '目标公司',
    filterTargetCompanySearchPlaceholder: '搜索目标公司',
    filterExcludeCompanySearchPlaceholder: '搜索排除公司',
    filterCompanySearchMore: '继续搜索公司',
    filterCompanyNoResults: '候选人履历中没有匹配公司',
    filterCompanyRelated: '关联公司',
    filterCompanyLegacy: '待确认',
    filterCompanyFilter: '公司匹配范围',
    filterCurrentCompanyOnly: '只看当前公司',
    filterExcludeCompanies: '排除公司',
    filterExcludeCompanyFilter: '排除公司范围',
    filterDomains: '公司域名',
    filterSchools: '学校',
    filterEducationDegrees: '学历',
    filterEducationMajors: '专业',
    filterLanguages: '语言',
    filterLanguageProficiencies: '语言等级',
    filterAnyProficiencyLevel: '任意语言等级',
    filterLanguageInputPlaceholder: '例如：English, Spanish, Mandarin',
    filterLanguageSelectPlaceholder: '选择常见语言',
    filterIsChinese: '华人',
    filterHasChinaExperience: '在华企业任职 / 中国经历',
    filterMustHave: '必须条件',
    filterPreferred: '加分条件',
    filterResearchTopics: '研究主题',
    filterExclude: '排除条件',
    filterRisk: '风险信号',
    filterListPlaceholder: '每行一个，或用逗号分隔',
    filterTagPlaceholder: '输入后回车添加',
    filterSelectPlaceholder: '请选择',
    filterAnyPlaceholder: '不限',
    filterOptionJunior: '初级',
    filterOptionMid: '中级',
    filterOptionSenior: '高级',
    filterOptionLead: '负责人',
    filterOptionManager: '经理',
    filterOptionDirector: '总监',
    filterOptionExecutive: '高管',
    filterOptionMax3JobsIn5Years: '5年内最多3份工作',
    filterOptionMax2JobsIn3Years: '3年内最多2份工作',
    filterOptionMin2YearsInLast2Jobs: '最近2份工作至少2年',
    filterOptionNoLimit: '不限',
    filterOptionIC: '独立贡献者',
    filterOptionFrontlineManager: '一线经理',
    filterOptionFunctionalLeader: '职能负责人',
    filterOptionBusinessOwner: '业务负责人',
    filterOptionEngineering: '工程研发',
    filterOptionProduct: '产品',
    filterOptionSales: '销售',
    filterOptionMarketing: '市场营销',
    filterOptionHumanResources: '人力资源',
    filterOptionFinance: '财务',
    filterOptionOperations: '运营',
    filterOptionCustomerSuccess: '客户成功',
    filterOptionDesign: '设计',
    filterOptionData: '数据',
    filterOptionLegal: '法务',
    filterOptionSupplyChain: '供应链',
    filterOptionConsulting: '咨询',
    filterOptionElementaryProficiency: '初级能力',
    filterOptionLimitedWorkingProficiency: '有限工作能力',
    filterOptionProfessionalWorkingProficiency: '专业工作能力',
    filterOptionFullProfessionalProficiency: '完全专业能力',
    filterOptionNativeBilingualProficiency: '母语或双语能力',
    filterOptionCurrent: '当前经历',
    filterOptionPast: '过往经历',
    filterOptionPastOnly: '仅过往经历',
    filterOptionBoth: '当前及过往经历',
    saveFilters: '保存更改',
    saveFiltersSuccess: '筛选条件已保存，重新推荐时会按新条件查找',
    saveFiltersFailed: '保存筛选条件失败',
    loadFiltersFailed: '获取筛选条件失败',
    filterValidationFailed: '请先补全筛选条件：{reason}',
    filterValidationRoleRequired: '岗位角色不能为空',
    filterValidationPositionSignalRequired: '职位名称或职能至少保留一项',
    filterValidationMatchSignalRequired: '技能关键词、目标公司或必须条件至少保留一项',
    filterValidationCompanyScopeRequiresCompany: '选择公司匹配范围前需要先选择目标公司',
    filterValidationExcludeScopeRequiresCompany: '选择排除公司范围前需要先选择排除公司',
    filterValidationLanguageLevelRequiresLanguage: '选择语言等级前需要先选择语言',
    jobNotReadyTitle: '岗位信息还可以补充',
    jobNotReadyDesc: '当前信息还不足以稳定推荐人才。请补充岗位名称、地点、经验或关键词后再试。',
    continueDialogue: '继续对话',
    candidateCount: '{count} 位候选人',
    enriching: '继续查找中',
    sourceWarning: '部分信息暂未更新',
    sortLabel: '推荐排序',
    sortScore: '匹配度',
    sortSource: '来源',
    sortStatus: '状态',
    localLoading: '正在查找合适候选人',
    emptyTitle: '暂无匹配候选人',
    emptyDesc: '可以放宽筛选条件后再试',
    failedTitle: '暂时没有推荐成功',
    failedDesc: '请稍后重试，或放宽筛选条件后再试',
    loadFailed: '获取推荐候选人失败，请稍后重试',
    pollFailed: '推荐结果更新失败，请稍后重试',
    recommendationAlreadyRunning: '推荐正在进行中，请稍等片刻',
    bindSuccess: '已加入岗位',
    bindOneSuccess: '候选人已加入岗位',
    bindFailed: '加入岗位失败',
    detailExpired: '该推荐结果已失效，请刷新推荐列表',
    detailLoadFailed: '获取候选人详情失败',
    unlockContact: '解锁联系方式',
    unlockContactWithCost: '消耗 {count} 联系积分解锁联系方式',
    unlockContactSuccess: '联系方式已解锁',
    unlockContactFailed: '解锁联系方式失败',
    unlockContactInsufficient: '联系积分不足，请购买或升级后解锁',
    insufficientContactPoints: '联系积分不足',
    noUnlockableContact: '暂无可解锁联系方式',
    verified: '已验证',
    reviewPending: '待审核',
    newCandidate: '新入库',
    source: '来源',
    match: '匹配',
    added: '已加入岗位',
    summary: '档案摘要',
    noSummary: '暂无摘要，可进入档案查看公开来源信息',
    missing: '缺失',
    add: '加入岗位',
    openSource: '打开来源',
    sourceLocal: '人才库',
    sourceAcademic: 'AI搜索',
    sourceContactout: 'AI搜索',
    unnamedCandidate: '未命名候选人',
    detailSections: {
      basic: '基础信息',
      work: '工作经历',
      education: '教育经历',
      contact: '联系方式',
      projects: '项目经历',
      evidence: '匹配证据',
      sources: '数据来源',
    },
    detailFields: {
      name: '姓名',
      full_name: '姓名',
      candidate_name: '候选人',
      title: '职位',
      headline: '标题',
      current_title: '当前职位',
      current_company: '当前公司',
      company: '公司',
      organization: '组织',
      location: '地点',
      city: '城市',
      country: '国家',
      summary: '摘要',
      bio: '简介',
      description: '描述',
      profile_url: '档案链接',
      url: '链接',
      linkedin_url: 'LinkedIn',
      start_date: '开始时间',
      end_date: '结束时间',
      school: '学校',
      degree: '学历',
      major: '专业',
      email: '邮箱',
      phone: '电话',
      source: '来源',
      candidate_id: '候选人ID',
      role: '当前角色',
      score: '匹配分',
      match_level: '匹配层级',
      work_experience: '累计工作年限',
      work_experience_no_gap: '连续工作年限',
      birth_year: '出生年份',
      is_chinese: '中国候选人',
      working_status: '在职状态',
      function_id: '职能ID',
      organization_id: '组织ID',
      institution_id: '院校ID',
      major_id: '专业ID',
      employment_type: '雇佣类型',
      location_type: '工作方式',
      work: '工作记录',
      project: '项目证据',
      publicSource: '公开来源',
      open: '打开',
      present: '至今',
    },
  },
  newMatchTag: '新增匹配人才',
  pendingTag: 'Pending',
  batchParseDialog: {
    title: '批量解析岗位',
    heroTitle: '先预检、再预览、最后导入',
    heroDesc:
      '这类 Excel 更像岗位台账，不建议直接盲解析成岗位。先识别表头和行数据，再由 HR 勾选确认后导入更稳。',
    heroTip:
      '已按你提供的岗位试单明细结构做了默认解析：岗位名称、核心职责、汇报上级、团队规划、薪资范围、岗位背景、核心能力诉求、HR 联系方式。',
    uploadTitle: '上传岗位 Excel',
    uploadDesc: '支持 .xlsx / .xls，默认读取第一个 Sheet 并自动识别常见岗位台账表头。',
    uploadDropTitle: '拖拽 Excel 到这里，或点击选择文件',
    uploadDropDesc: '建议优先使用一行一个岗位、表头完整的业务台账',
    sheetName: '工作表：{name}',
    statsTitle: '解析概览',
    reset: '重置',
    totalRows: '识别行数',
    readyRows: '可直接导入',
    warningRows: '需人工确认',
    skippedRows: '已跳过',
    selectReady: '勾选可导入行',
    clearSelection: '清空勾选',
    previewTitle: '岗位预览',
    previewDesc: '左侧查看整体，右侧查看单行生成的岗位画像。',
    generatedProfile: '生成的岗位画像',
    empty: '请先上传 Excel 文件',
    invalidFile: '请上传 Excel 文件（.xlsx / .xls）',
    parseSuccess: '已识别 {count} 行岗位数据',
    parseFailed: 'Excel 解析失败，请检查文件格式或表头结构',
    footerHint: '已选择 {count} 条岗位进行导入',
    importAction: '导入 {count} 条岗位',
    importSuccess: '已导入 {count} 条岗位到列表',
    selectAtLeastOne: '请至少勾选一条岗位数据',
    unnamedJob: '未命名岗位',
    columns: {
      row: '行号',
      status: '状态',
      jobName: '岗位名称',
      location: '地点',
      salary: '薪资',
      profile: '预解析岗位画像',
      hr: '对接 HR',
      reportTo: '汇报上级',
    },
    status: {
      ready: '可导入',
      warning: '待确认',
      skipped: '已跳过',
    },
  },
  externalLinkDialog: {
    title: '请选择你的领英账号类型',
    destination: '根据你的领英账号类型选择对应入口，跳转后可直接进入搜索页面：',
    linkedin: '领英个人/商务版(Business)',
    salesNavigator: '领英销售版(Sales)',
    recruiterSearch: '领英企业招聘版(Recruiter)',
  },
  matchRatingFilter: '匹配度',
  matchRatingSelected: '已选 {count} 项',
  aiAnalysis: 'AI分析',
  analysisPendingTitle: '待分析',
  analysisPendingHint: '已进入分析队列，结果生成后会自动展示。',
  analysisReAnalyzingTitle: '重新分析中',
  analysisReAnalyzingHint: '岗位已调整，系统会按 5 分钟任务节奏重新生成匹配分析。',
  analysisNotPointsTitle: '积分不足',
  analysisNotPointsHint: '本次分析任务执行时积分不足，补充积分后可重新触发分析。',
  analysisNotVipTitle: '匹配积分不足',
  analysisNotVipHint: '本次分析任务执行时 AI积分不足，补充积分后可重新触发分析。',
  analysisAnalyzingTitle: 'AI分析中',
  analysisAnalyzingHint: '正在结合岗位要求与候选人经历生成分析结果。',
  analysisFailedTitle: '分析失败',
  analysisFailedHint: '分析任务未完成，请稍后重试或刷新查看。',
  analysisOldJdHint: '该分析结果来自旧 JD，岗位重新分析完成后会自动更新。',
  analysisDelayedTitle: '分析耗时较长',
  analysisDelayedHint: '通常会在 10 分钟内返回结果。你可以稍后查看，或立即手动刷新。',
  feedback: {
    title: 'AI 反馈',
    agreeTitle: '认可',
    agreeTitleWithIcon: '👍 认可（Agree）',
    disagreeTitle: '不认可',
    disagreeTitleWithIcon: '👎 不认可（Disagree）',
    reasonLabel: '反馈原因',
    customLabel: '补充说明',
    customPlaceholder: '请输入反馈内容',
    selectReason: '请选择反馈原因',
    customRequired: '请输入反馈内容',
    completed: '已评价',
    submitSuccessAgree: '已提交正向反馈',
    submitSuccessDisagree: '已提交负向反馈',
    options: {
      agree: {
        domainFit: '行业 / 领域匹配',
        businessFit: '业务场景匹配',
        experienceFit: '工作经验相关性高',
        strongPerformance: '过往业绩表现强',
        preferredMatch: '符合加分项（Preferred）',
        other: '其他（自定义输入）',
      },
      disagree: {
        domainMismatch: '行业 / 领域不匹配',
        missingRequiredExperience: '缺少关键经验（Must Have）',
        experienceLevelMismatch: '经验层级不匹配',
        roleMismatch: '岗位匹配度低',
        redFlagTriggered: '触发风险项',
        other: '其他（自定义输入）',
      },
    },
  },
  create: '新建岗位',
  name: '岗位名称',
  description: '岗位描述',
  status: '状态',
  actions: '操作',
  view: '查看',
  aiMailAction: 'AI InMail',
  pipelineAdvance: '下一流程',
  edit: '编辑',
  rename: '重命名',
  open: '开启岗位',
  close: '关闭岗位',
  retry: '重新分析',
  delete: '删除',
  jd: '岗位JD',
  createTitle: '创建岗位',
  editTitle: '编辑岗位',
  detailTitle: '岗位详情',
  resumeSummaryEntry: '简历汇总',
  resumeSummaryPending: '简历汇总独立入口待后端 API 接入',
  resumeSummaryBack: '返回候选人列表',
  resumeSummaryOverview: '岗位总览',
  resumeSummaryCandidateCount: '候选人数',
  resumeSummaryAverageScore: '平均匹配分',
  resumeSummaryAverageExperience: '平均工作年限',
  resumeSummaryProcessDistribution: '流程分布',
  resumeSummaryAllCandidates: '候选人简历汇总',
  resumeSummaryEmpty: '当前岗位暂无可展示的简历数据',
  resumeSummaryLoadFailed: '简历汇总加载失败',
  resumeSummaryContact: '联系方式',
  resumeSummaryExperience: '经历摘要',
  resumeSummaryEducation: '教育背景',
  resumeSummaryAiAnalysis: 'AI 分析',
  resumeSummaryRecency: '近期匹配判断',
  resumeSummaryStrengths: '优势亮点',
  resumeSummaryRisks: '风险提示',
  resumeSummaryNoAnalysis: '暂无 AI 分析内容',
  pipelineSubmitted: '筛选中',
  pipelineScreening: '沟通中',
  pipelineShortlisted: '推荐中',
  pipelineInterview: '面试环节',
  pipelineOffer: 'Offer 谈判',
  pipelinePreOnboard: 'Offer 待入职',
  pipelineOnboard: '人才到岗',
  pipelineMore: '更多',
  pipelineRejectedScreening: '初筛淘汰',
  pipelineRejectedInterview: '面试淘汰',
  pipelineOfferRejected: 'Offer 拒绝',
  pipelineSalaryNegotiationFailed: '薪资谈判失败',
  pipelineWithdrawn: '已放弃',
  namePlaceholder: '请输入岗位名称（可选）',
  descPlaceholder: '请输入岗位描述（可选）',
  jdPlaceholder: '请输入岗位 JD（必填）',
  createSuccess: '创建成功',
  updateSuccess: '更新成功',
  deleteSuccess: '删除成功',
  confirmDelete: '确定删除岗位「{name}」吗？',
  sidebarRenameTitle: '重命名岗位',
  sidebarNewName: '请输入岗位新名称',
  retrySuccess: '已提交重新分析',
  statusToggleSuccess: '岗位状态已更新',
  bind: '绑定候选人',
  bindTitle: '绑定候选人与岗位',
  bindToJob: '绑定到岗位',
  unbind: '解绑',
  remove: '移除',
  selectJob: '选择岗位',
  selectTag: '选择标签',
  selectCandidate: '选择候选人',
  bindNoJobTitle: '当前未指定岗位',
  bindNoJobDesc: '请从岗位列表中的某个岗位进入绑定弹窗。',
  bindTagMultiTitle: '选择一个或多个候选人标签',
  bindSelectedTagCount: '已选 {count} 个标签',
  bindTagPlaceholder: '请选择标签，可多选',
  bindFilterTitle: '使用筛选条件圈定候选人',
  bindFilterNote: '会按所选标签与筛选条件批量拉取候选人，并绑定到当前岗位。',
  bindUiConfirmSuccess: '已确认筛选与标签选择',
  bindNoCandidates: '当前筛选条件下没有可绑定的候选人',
  bindResult: '绑定完成，成功 {success} 人，失败 {failed} 人',
  bindFilters: {
    nationality: '国籍 / 身份',
    nationalityAll: '不限',
    nationalityChinese: '华人候选人',
    nationalityNonChinese: '非华人候选人',
    language: '语言',
    languagePlaceholder: '选择语言',
    function: '职能',
    functionPlaceholder: '选择职能',
  },
  bindSuccess: '绑定成功',
  unbindSuccess: '解绑成功',
  refresh: '刷新',
  boundCandidate: '候选人',
  boundStatus: '分析状态',
  resumeParseTitle: '简历解析导入',
  resumeParseSubtitle: '支持 PDF 简历批量上传，自动提交到当前岗位',
  resumeParseFormatPdf: 'PDF 简历',
  resumeParseFormatWord: 'Word 简历',
  resumeParseFormatImage: '图片简历',
  resumeParseUploadTitle: '上传简历文件',
  resumeParseUploadHint: '点击或拖拽 PDF 文件到此处',
  resumeParseUploadTip: '支持多个文件，单次最多 500 份',
  resumeParseScopeTitle: '解析范围',
  resumeParseSourceRemark: '简历来源备注',
  resumeParseSourceRemarkPlaceholder:
    '例如：海外招聘平台（LinkedIn、JobsDB）、海外校招官网、员工内推收集',
  resumeParseScopeNote: '该备注会随本批简历提交，用于后续归档与追踪。',
  resumeParseMetaTitle: '解析概览',
  resumeParseMetaEmpty: '上传文件后展示解析概览',
  resumeParseQualityEmpty: '解析完成后展示质量评分',
  resumeParseUploadAssistTitle: '上传说明',
  resumeParseUploadAssistDesc: '支持拖拽或点击上传，单次最多 500 份。',
  resumeParseUploadAssistTip1: '图片建议清晰扫描，避免反光或倾斜',
  resumeParseUploadAssistTip2: 'PDF/Word 推荐保留完整文字层',
  resumeParseUploadAssistTip3: '解析后可在右侧直接编辑并同步 JSON',
  resumeParseUploadAssistFlowTitle: '解析流程',
  resumeParseUploadAssistFlow1: '上传文件',
  resumeParseUploadAssistFlow2: '解析结构',
  resumeParseUploadAssistFlow3: '编辑与保存',
  resumeParseSelected: '已选择 {count} 个文件',
  resumeParseClear: '清空',
  resumeParseStart: '开始解析',
  resumeParseLimit: '单次最多上传 500 个文件',
  resumeParseFolderUpload: '选择文件夹',
  resumeParsePdfOnly: '当前仅支持 PDF 简历',
  resumeParseFileTooLarge: '单个 PDF 文件不能超过 5MB',
  resumeParseJobMissing: '缺少岗位 ID，请从岗位列表重新进入',
  draftJobImportDisabled: '草稿岗位不能导入候选人，请先完成岗位创建',
  resumeParseUploadSubmitted: '已提交 {count} 份简历，后台解析中',
  resumeParseQueued: '已提交解析任务',
  resumeParseCompleted: '解析完成，已生成 JSON 预览',
  resumeParseFailed: '解析失败，请重试或更换文件',
  resumeParseSignFailed: '文件 {name} 获取上传授权失败，请重试',
  resumeParseUploadFailed: '文件 {name} 上传失败，请重试',
  resumeParseFileInvalid: '文件 {name} 信息异常，请重新选择',
  resumeParseCurrentFile: '当前文件',
  resumeParseFileMissing: '无法读取文件，请重新选择',
  resumeParseResultTitle: '解析结构',
  resumeParseVisualTitle: '可视化预览',
  resumeParseResultJson: 'JSON 预览（完整）',
  resumeParseResultEmpty: '上传文件并点击“开始解析”后生成预览',
  resumeParseStatusIdle: '等待上传',
  resumeParseStatusParsing: '解析中',
  resumeParseStatusReady: '已生成',
  resumeParseWarnings: '解析提示',
  resumeParseQuality: '解析质量',
  resumeParseEdit: '编辑',
  resumeParseEditDone: '完成编辑',
  resumeParseEditTip: '请先解析简历',
  resumeParseExpand: '展开',
  resumeParseCollapse: '收起',
  resumeParseCopyJson: '复制 JSON',
  resumeParseDownloadJson: '下载 JSON',
  resumeParseCopySuccess: 'JSON 已复制',
  resumeParseCopyFailed: '复制失败，请手动复制',
  resumeParseSections: {
    basic: '基本信息',
    education: '教育背景',
    internship: '实习经验',
    experience: '工作经历',
    honor: '荣誉奖项',
    skill: '技能证书',
    project: '项目经历',
  },
  createFlow: {
    backToList: '返回岗位列表',
    steps: {
      input: '1. 输入 JD',
      review: '2. 审核解析结果',
    },
    defaultGreetingName: '你好',
    placeholder:
      '请粘贴完整 JD，例如：\n负责海外销售团队管理，拓展新加坡及东南亚市场，聚焦半导体设备客户开发；\n要求 3-5 年以上行业经验，英语可作为工作语言，具备客户关系维护与技术沟通能力。',
    suggestions: {
      item1: '旧金山湾区的软件工程师，目标候选人来自 B 轮公司，熟悉 Python 和 Node.js',
      item2: '欧洲市场营销经理，要求德语可作为工作语言，并有大型企业经验',
      item3: '澳大利亚高级科学家，8 年以上相关经验',
      item4: '伦敦咨询顾问，具备 2 年以上头部咨询公司经验',
      item5: '销售总监，base 新加坡，半导体设备行业，负责东南亚市场拓展',
    },
    signals: {
      location: '地点',
      jobTitle: '岗位名称',
      yearsOfExperience: '经验年限',
      industry: '行业',
      skills: '技能',
    },
    input: {
      title: '{name}，你想招什么样的人才？',
      subtitle: '粘贴 JD 或一句话描述招聘需求，AI 会生成搜索策略和候选人推荐。',
      jobDescription: '岗位描述',
      analyze: '解析 JD',
      suggestionsTitle: '示例灵感',
      suggestionsSubtitle: '也可以先点一条示例，再二次编辑成你自己的岗位描述。',
    },
    analysis: {
      kicker: 'EasyHire AI 正在解析',
      waitingInput: '正在等待 JD 输入...',
      inputLabel: 'JD 输入',
      outputLabel: 'AI 输出',
      outputItem1: '岗位标题候选与职能大类',
      outputItem2: '地域 / 行业 / 年限 / 关键词',
      outputItem3: '筛选权重与评估框架',
    },
    analysisSteps: {
      step1: {
        title: '正在理解 JD 语义',
        short: '识别角色、地区与基础上下文',
        description: 'AI 正在拆解原始 JD 文本，抽取岗位名称、工作地点、组织背景和关键职责。',
      },
      step2: {
        title: '正在提炼核心筛选条件',
        short: '经验、行业、关键词与权重',
        description: 'AI 正在整理经验范围、行业约束、关键词与权重，准备形成可操作的招聘画像。',
      },
      step3: {
        title: '正在生成评估框架',
        short: '必备项、加分项与评分焦点',
        description: 'AI 正在构建候选人评估框架，帮助 HR 后续快速筛选和人工校准。',
      },
    },
    generating: {
      step1: '正在分析招聘意图...',
      step2: '提取关键特征信号：',
      step3: '推断职位隐含预期：',
      step4: '构建候选人评估标准...',
      step5: '正在生成结构化需求...',
      jobTitle: '职位',
      jobTitleValue: '销售经理',
      location: '地点',
      locationValue: '美国',
      industry: '行业',
      industryValue: '消费电子',
      level: '职级',
      levelValue: '经理级别',
      experience: '经验',
      experienceValue: '5-10年',
    },
    review: {
      sidebarKicker: '确认岗位画像',
      sidebarTitle: '编辑岗位画像',
      sidebarDesc: '检查 AI 解析出的筛选条件，必要时手动修正后再创建岗位。',
      searchGroups: '搜索字段分组',
      quickNav: '快速定位到对应模块',
      currentMock: '当前 mock 样本',
      mockIndicator: '第 {index} / {total} 组',
      switchMock: '切换下一组 mock 结果',
      summaryCount: '{count} 项条件',
      backToInput: '返回重填 JD',
      create: '确认创建岗位',
      update: '保存岗位修改',
      unnamedJob: '未命名岗位',
      notIdentified: '未识别',
      sections: {
        general: '基础信息',
        location: '地区经验',
        job: '岗位关键词',
        industry: '行业信息',
        weights: '筛选权重',
        framework: '评估框架',
        source: '原始 JD',
      },
      summary: {
        titleSuggestion: '岗位标题建议',
        editable: '可继续修改',
        coreLocation: '核心地域',
        coreIndustry: '核心行业',
        experienceRange: '经验范围',
        weight: '权重 {value}',
        level: '职级 {value}',
      },
      general: {
        title: '基础岗位信息',
        jobName: '岗位名称',
        jobNamePlaceholder: '请输入岗位名称',
        functionRoot: '职能大类',
        functionRootPlaceholder: '请输入职能大类',
        domain: '岗位领域',
        domainPlaceholder: '请输入岗位领域',
        description: '岗位描述备注',
        descriptionPlaceholder: '可补充给团队看的岗位描述备注',
      },
      location: {
        title: '地区与经验范围',
        workLocation: '工作地点',
        workLocationPlaceholder: '请输入工作地点',
        ageRange: '年龄范围',
        ageRangePlaceholder: '例如 25-38',
        experience: '经验要求',
        experiencePlaceholder: '例如 3-5 年',
        seniority: '职级',
        seniorityPlaceholder: '请输入职级',
      },
      job: {
        title: '岗位候选标题与关键词',
        titles: '岗位候选标题',
        titlesPlaceholder: '一行一个岗位标题',
        keywords: '关键词',
        keywordsPlaceholder: '一行一个关键词',
      },
      industry: {
        title: '行业信息',
        primary: '一级行业',
        primaryPlaceholder: '请输入一级行业',
        secondary: '二级行业',
        secondaryPlaceholder: '一行一个二级行业',
      },
      weights: {
        title: '筛选权重',
        domain: '领域',
        language: '语言',
        age: '年龄',
      },
      framework: {
        title: '评估框架',
        mergedLabel: '评估框架明细',
        mergedPlaceholder:
          '每行一条，格式示例：\n角色总结：负责东南亚市场半导体客户开发\n必备条件：3 年以上半导体设备销售经验\n加分条件：有新加坡本地客户资源\n推断条件：能独立推进复杂客户谈判\n评分重点：行业相关性与客户开拓能力',
        roleSummary: '角色总结',
        roleSummaryPlaceholder: '请输入角色总结',
        mustHave: '必备条件',
        mustHavePlaceholder: '一行一个必备条件',
        preferred: '加分条件',
        preferredPlaceholder: '一行一个加分条件',
        inferred: '推断条件',
        inferredPlaceholder: '一行一个推断条件',
        scoringFocus: '评分重点',
        scoringFocusPlaceholder: '一行一个评分重点',
      },
      source: {
        title: '原始 JD',
      },
    },
    workspace: {
      sourceLabel: '分析依据：',
      interpretedTitle: 'EasyHire AI 已将你的输入整理成结构化岗位画像',
      priorityTitle: '当前匹配会优先关注',
      whyTitle: 'AI 为什么这样拆解',
      criteriaTitle: '招聘判断标准',
      criteriaInputPlaceholder: '请输入筛选标准...',
      addCriteriaAction: '添加标准',
      criteriaAction: '编辑标准',
      confirmedTitle: '已从输入中确认',
      inferredTitle: 'AI 推断得到',
      needConfirmTitle: '建议继续确认',
      mustHaveTitle: '核心必备要求',
      preferredTitle: '倾向性加分要求',
      refineAction: '继续补充要求',
      refineTitle: '补充岗位要求',
      reanalyzeAction: '重新分析岗位',
      reanalyzingAction: '正在重新分析...',
      saveChangesAction: '保存修改',
      savingAction: '正在保存修改并重新分析中...',
      savingHint: '预计 15 秒内完成提交，新的 JD 已同步展示，分析结果会随后刷新。',
      originalInputLabel: '当前分析文本',
      filterSummary: '岗位摘要',
      criteriaFocus: '当前筛选关注点',
      refinePlaceholder:
        '可直接在原始 JD 上补充或修改，例如：找人地址调整一下，只找上海，需要拥有 AI 设计能力',
      defaultNeedConfirm: '团队管理范围、汇报关系与业务阶段',
      criteriaGroups: {
        mustHave: '匹配项',
        niceToHave: '加分项',
        risk: '风险项-满足风险项则评分不合格',
      },
      editorResizeHint: '可拖动右下角调整输入框高度',
      groups: {
        coreRole: 'A 组：核心岗位定义',
        background: 'B 组：背景与业务上下文',
        skills: 'C 组：关键词与筛选信号',
        optional: 'D 组：加分项与推断项',
      },
      fields: {
        roleSummary: '角色总结',
        mustHave: '必备条件',
        preferred: '加分条件',
        inferred: '推断条件',
        scoringFocus: '评分重点',
      },
      quickAdditions: {
        title: '一键补充常见要求',
        item1: '有从 0 到 1 搭建团队经验',
        item2: '具备跨区域客户开拓经验',
        item3: '能适应高增速业务节奏',
      },
      priorities: {
        jobTitle: '岗位名称匹配度',
        function: '职能匹配度',
        industry: '行业相关度',
        skills: '关键词 / 领域信号',
        level: '职级与经验匹配',
        language: '语言 / 区域背景',
      },
      priorityLevels: {
        high: '高',
        medium: '中',
        optional: '可选',
      },
    },
    messages: {
      enterJdFirst: '请先输入或粘贴岗位 JD',
      mockGenerated: '已根据 mock 数据生成岗位解析结果',
      mockSwitched: '已切换到第 {index} 组 mock 解析结果',
      confirmJobName: '请先确认岗位名称',
      enterRefineMessage: '请输入补充说明后再重新分析',
      refineUpdated: '岗位要求已更新',
      createSubmitted: '已提交保存，正在后台处理并刷新岗位分析',
    },
  },
}

export default jobs
